import { z } from 'zod'

export const ImageReferenceSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('data-uri'), value: z.string() }),
  z.object({ kind: z.literal('url'), url: z.string().url() }),
  z.object({ kind: z.literal('field'), fieldKey: z.string() }),
  z.object({ kind: z.literal('host-asset'), assetId: z.string() }),
])
export type ImageReference = z.infer<typeof ImageReferenceSchema>

export type ImageBuffer = Uint8Array

export const ImageAssetSchema = z.object({
  id: z.string().min(1),
  name: z.string(),
  mimeType: z.string(),
  // Original encoded image bytes (PNG/JPEG/SVG/…), NOT rasterized.
  data: z.instanceof(Uint8Array),
  createdAt: z.string(),
})
export type ImageAsset = z.infer<typeof ImageAssetSchema>

/**
 * A resolved + rasterized image, keyed in the resolvedImages map by the
 * source component's `id` (one entry per placement). `buffer` is the 1-bit
 * row-major MSB-first packed bitmap exactly sized to `widthDots × heightDots`
 * — the layout `serialize.renderImage` hexes into `^GFA`. The dims travel
 * with the buffer so `render-plan` never recomputes the fit.
 */
export interface ResolvedImage {
  buffer: ImageBuffer
  widthDots: number
  heightDots: number
}
